import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Table, Row, Button, Popconfirm } from 'antd';
import { PopUpForm } from '../../../lib/ui/popupform';
import { showErrorInNotification, formatMoney } from '../../../lib/util';

const rules_cols = []

class ReconcilerExclusionRules extends Component {
  constructor(props) {
    super(props)

    this.state = {
      other_recons: [],
      form_visibility: false,
      form_data: {}
    }
    this.list_other_reconcilers = RESTExecutor.list().config({
      label: 'recon_rules_for_exclusion',
      params: {
        pagination: false
      }
    }).forId(props.recon_id).callbacks((success) => {
      let options = [];
      success.result.rows.map((item) => {
        options.push({ text: item.name, value: item.id });
      });
      this.setState({ other_recons: options })
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.settings);

    this.list_exclusions = RESTExecutor.list().config({
      label: 'exclusion_list',
      params: {
        per_page: 10
      }
    }).callbacks(() => { }, (error) => {
      showErrorInNotification(error)
    }).forId(props.recon_id).connect(props.domains.settings);


    this.post_exclusions = RESTExecutor.post().config({
      label: 'exclusion_list'
    }).forId(props.recon_id).callbacks((success) => {
      this.setState({
        form_visibility: false,
        form_data: {}
      })
      this.list_exclusions.execute();
    }).connect(props.domains.settings);



    // this.list_other_reconcilers.execute();
    this.list_exclusions.execute();

    this.delete_exclusion = RESTExecutor.delete().config({
      label: 'exclusion_detail',
      params: {}
    }).callbacks((success) => {
      this.list_exclusions.config({
        per_page: 10, page: 1
      }).execute()
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.settings);

  }

  render() {

    let list_exclusions_resp = this.list_exclusions.response();
    let list_exclusions_data = list_exclusions_resp.result || {};

    let post_exclusions_resp = this.post_exclusions.response();

    let rowsData = list_exclusions_data.rows || [];
    let rowsMeta = list_exclusions_resp.meta || {};

    const schema = [
      { index: 'excluded_group_id', name: "Processor", type: 'networkselect', url: `/reconcilers/${this.props.recon_id}/exclusion-group-list`, filterable: true },
      { index: 'reconciled', name: 'Processed', type: 'bool' }
    ]

    return (
      <div>
        <PopUpForm
          width="60%"
          key={`${this.state.selected_id}upload`}
          title={"Exclusion Rule"}
          show_title_only
          forCreate={true}
          initialData={this.state.form_data}
          fields={schema}
          open={this.state.form_visibility}
          networkState={post_exclusions_resp}
          onClose={() => {
            console.log("closing form")
            this.setState({
              form_visibility: false,
              form_data: {}
            })
          }
          }
          onSubmit={(data) => {
            console.log("DATA", data);

            this.post_exclusions.execute(data);
          }}
        />

        <Table
          scroll={{ x: true }}
          dataSource={rowsData}
          className='ant-table-small-noborder customTable'
          // loading={list_exclusions_resp.fetching}
          title={() => <Row type='flex' justify='space-between' style={{
            alignItems: 'center'
          }}><div></div>
            <Button type='primary' onClick={() => {
              this.setState({
                form_visibility: true,
              })
            }}>Add New Rule</Button>
          </Row>}
          columns={[
            {
              title: "Processor", dataIndex: 'id', key: 'excluded_group_id', render: (id, data) => {
                let ref = data.__references__ || {};
                let group = ref.excluded_group_id || {};
                return group.name;
              }
            },
            { title: "Processed", dataIndex: 'reconciled', render: (reconciled) => `${reconciled}` },
            {
              title: "", dataIndex: 'id', render: (id) => <span>
                <Popconfirm title="Are you sure you want to delete this rule?" onConfirm={() => {
                  this.delete_exclusion.config({
                    params: {
                      rule_id: this.props.rule_id,
                      exclusion_id: id
                    }
                  }).execute();
                }}>
                  <Button type='link' style={{ color: 'red' }}>Delete</Button>
                </Popconfirm>
              </span>
            }
          ]}
          size='small'
          rowKey={(record) => record.id}
          pagination={{
            simple: false,
            position: 'bottom',
            onChange: (current, size) => {
              this.list_exclusions.config({
                params: {
                  per_page: size,
                  page: current,
                  rule_id: this.props.rule_id
                }
              }).execute();
            },
            defaultCurrent: 1,
            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
            // defaultPageSize: 20,
            pageSize: (rowsMeta && rowsMeta.requested_count),

            total: (rowsMeta && rowsMeta.total_count),
            showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${formatMoney(total, 0)} items`
          }}
        />
      </div>
    );
  }
}

export default withDomains(ReconcilerExclusionRules, "settings");
